import { D2DRequestsFilters } from "../../../../api/d2d/d2dApiInterfaces";
import { D2DOrderRow } from "../components/D2DActionMenu/D2DActionMenu";

export type D2DRequestsAction =
  | { type: "SET_PAGE"; payload: number }
  | { type: "SET_PAGE_ROW_SIZE"; payload: number }
  | { type: "SET_LOADING"; payload: boolean }
  | {
      type: "SET_DATA";
      payload: { requests: D2DOrderRow[]; totalCount: number };
    }
  | { type: "SET_ERROR"; payload: boolean }
  | { type: "SET_FILTERS"; payload: D2DRequestsFilters }
  | {
      type: "UPDATE_ROW";
      payload: { id: string; partial: Partial<D2DOrderRow> };
    }
  | {
      type: "MERGE_SERVER_DATA";
      payload: { requests: D2DOrderRow[]; totalCount: number };
    };

export const setPageAction = (page: number): D2DRequestsAction => ({
  type: "SET_PAGE",
  payload: page,
});

export const setPageRowSizeAction = (
  pageRowSize: number
): D2DRequestsAction => ({
  type: "SET_PAGE_ROW_SIZE",
  payload: pageRowSize,
});

export const setLoadingAction = (loading: boolean): D2DRequestsAction => ({
  type: "SET_LOADING",
  payload: loading,
});

export const setDataAction = (requests: D2DOrderRow[], totalCount: number) => ({
  type: "SET_DATA" as const,
  payload: { requests, totalCount },
});

export const setErrorAction = (error: boolean): D2DRequestsAction => ({
  type: "SET_ERROR",
  payload: error,
});

export const setFiltersAction = (
  filters: D2DRequestsFilters
): D2DRequestsAction => ({
  type: "SET_FILTERS",
  payload: filters,
});

export const updateRowAction = (
  id: string,
  partial: Partial<D2DOrderRow>
): D2DRequestsAction => ({
  type: "UPDATE_ROW",
  payload: { id, partial },
});

export const mergeServerDataAction = (
  requests: D2DOrderRow[],
  totalCount: number
): D2DRequestsAction => ({
  type: "MERGE_SERVER_DATA",
  payload: { requests, totalCount },
});
